import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
//UI
import InputForm from '../../../components/Inputs/formInput/InputForm';
import BtnContent from '../../../components/buttons/BtnContent';
import Error from '../../../components/errors/Error';
import HeaderSection from '../../../components/headers/catalogs/HeaderSection';
import HomeLayout from '../../../layouts/HomeLayout';
import MainLoader from '../../../components/Loaders/MainLoader';
import HeaderForm from '../../../components/headers/catalogs/HeaderForm';
//SLICES
import { getConfigThunk, initialStateConfig, chageStatePeriodsThunk } from '../../../store/slices/catalogs/config.slice';
import { formatDateToLocal } from '../../../utils/funtions';
import { Toast } from '../../../resources/utils';

const SpacePeriodForm = () => {
    const dispatch = useDispatch();
    const { space_period_id } = useParams();
    const { t } = useTranslation();
    const { setValue, register, handleSubmit, formState: { errors } } = useForm();
    const { item, error, message } = useSelector(state => state.configurations);
    const isLoading = useSelector(state => state.isLoadingSlice);

    useEffect(() => {
        dispatch(getConfigThunk(space_period_id));
        return () => {
            dispatch(initialStateConfig());
        }
    }, [])

    useEffect(() => {
        if (space_period_id) {
            setValue('reservationSpacePeriodStart', formatDateToLocal(item?.fecha_inicio_reservacion_cupo));
            setValue('reservationSpacePeriodEnd', formatDateToLocal(item?.fecha_fin_reservacion_cupo));
        }
    }, [item, setValue]);

    const onSubmit = (data) => {
        dispatch(chageStatePeriodsThunk(space_period_id, data));
    };

    useEffect(() => {
        if (message === "Registro actualizado correctamente ") {
            Toast.fire({
                icon: 'success',
                title: message,
            });
        }
    }, [message]);

    return (
        <HomeLayout>
            {isLoading ? (
                <MainLoader />
            ) : (
                <div className='mx-5 my-5 w-full'>
                    {error ? <Error state={error} /> : " "}
                    <HeaderForm title={t("Configuración general")} />
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <HeaderSection title={t("Fecha habilitante para reservación de cupo")} />
                        <div className='flex gap-2 p-2 mb-5'>
                            <InputForm
                                spam={true}
                                label={t("Fecha de inicio")}
                                type="datetime-local"
                                input="input"
                                cols={1}
                                register={register("reservationSpacePeriodStart", { required: true })}
                                errors={errors.reservationSpacePeriodStart && (<span className="text-red-500 text-xs">{t("required_information")}</span>)}
                            />
                            <InputForm
                                spam={true}
                                label={t("Fecha de finalizacion")}
                                type="datetime-local"
                                input="input"
                                cols={1}
                                register={register("reservationSpacePeriodEnd", { required: true })}
                                errors={errors.reservationSpacePeriodEnd && (<span className="text-red-500 text-xs">{t("required_information")}</span>)}
                            />
                        </div>
                        <div className="flex items-center justify-start py-5 gap-2 border-t-2 border-p-green mt-8">
                            <BtnContent type="submit">{t("save_button")}</BtnContent>
                            <BtnContent cancel={true} to={`/panel/configurations`}>{t("canceled_button")}</BtnContent>

                        </div>
                    </form>
                </div>
            )}
        </HomeLayout>
    );
};

export default SpacePeriodForm;
